module.exports = __webpack_public_path__ + "img/高损耗.362458ae.png";